import {BBModel} from "../../bb_model";
import {BaseModel} from "../base";
import {eventChain} from "../../services/event_chain";
import {translations} from "../../constants/translations";

class EventChainModel extends BaseModel {

    constructor(data) {

        super(...arguments);

        this.capacity_view = this.setCapacityView(this.capacity_view);
        if (this.start_date) {
            this.start_date = moment(this.start_date);
        }
        if (this.end_date) {
            this.end_date = moment(this.end_date);
        }
    }

    setCapacityView(capacity_view) {
        let capacity_view_str;
        switch (capacity_view) {
            case 0:
                capacity_view_str = 'DO_NOT_DISPLAY';
                break;
            case 1:
                capacity_view_str = 'NUM_SPACES';
                break;
            case 2:
                capacity_view_str = 'NUM_SPACES_LEFT';
                break;
            case 3:
                capacity_view_str = 'NUM_SPACES_AND_SPACES_LEFT';
                break;
            default:
                capacity_view_str = 'NUM_SPACES_AND_SPACES_LEFT';
        }
        return capacity_view_str;
    }

    name() { //comment
        return this._data.name;
    }

    /**
     * @description
     * Verify if is a single booking
     *
     * @returns {array} If maximum number of bookings is equal with 1 and not have an ticket sets
     */
    isSingleBooking() {
        return (this.max_num_bookings === 1) && !this.$has('ticket_sets');
    }

    /**
     * @description
     * Checks if this is considered a valid tickets
     *
     * @returns {boolean} If this have an ticket sets
     */
    hasTickets() {
        return this.$has('ticket_sets');
    }

    /**
     * @description
     * Get the tickets of the event
     *
     * @returns {promise} A promise for the tickets
     */
    getTickets() {
        return new Promise((resolve, reject) => {
            if (this.tickets) {
                resolve(this.tickets);
            } else {
                if (this.$has('ticket_sets')) {
                    this.$get('ticket_sets').then((tickets) => {
                            this.tickets = [];
                            for (const ticket of Array.from(tickets)) {
                                // mark that this ticket is part of ticket set so that the range can be calculated correctly
                                ticket.ticket_set = true;
                                this.tickets.push(new BBModel.EventTicket(ticket));
                            }
                            this.adjustTicketsForRemaining();
                            return resolve(this.tickets);
                        }
                    );
                } else {

                    //name: $translate.instant('COMMON.TERMINOLOGY.ADMITTANCE'),
                    this.tickets = [new BBModel.EventTicket({
                        name: translations.MODEL.EVENT_CHAIN.ADMITTANCE,
                        min_num_bookings: 1,
                        max_num_bookings: this.max_num_bookings,
                        type: 'normal',
                        price: this.price
                    })];
                    this.adjustTicketsForRemaining();
                    resolve(this.tickets);
                }
            }
        });
    }

    /**
     * @description
     * Adjust the number of tickets that can be booked due to changes in the number of remaining spaces for each ticket set
     *
     * @returns {object} The returned adjust tickets for remaining
     */
    adjustTicketsForRemaining() {
        if (this.tickets) {
            return (() => {
                const result = [];
                for (this.ticket of Array.from(this.tickets)) {
                    result.push(this.ticket.max_spaces = this.spaces);
                }
                return result;
            })();
        }
    }

    /**
     * @description
     * Get the event ticket type. We can have 3 types:
     * 1 - GENERIC_TICKET_TYPE when question_per_ticket = false && email_per_ticket = false
     * GENERIC_TICKET_TYPE - display 1 client form only (including any client questions) and
     * 1 booking question form (if applicable)
     *
     * 2 - QUESTIONS_PER_TICKET_TYPE when question_per_ticket = true && email_per_ticket = true
     * QUESTIONS_PER_TICKET_TYPE - display 1 client form only (including any client questions) and
     * 1 booking question form per ticket (if applicable)
     * (in the case of getting QUESTIONS_PER_TICKET_TYPE backend is sending wrong data, it should be
     * question_per_ticket = true && email_per_ticket = false)
     *
     * 3 - DETAILS_PER_TICKET_TYPE when question_per_ticket = false && email_per_ticket = true
     * DETAILS_PER_TICKET_TYPE - display 1 initial client form (including customer questions) and
     * 1 client form per ticket including booking questions for each
     * (in the case of getting DETAILS_PER_TICKET_TYPE backend is sending wrong data, it should be
     * question_per_ticket = true && email_per_ticket = true)
     *
     * @returns {string} Event ticket type
     */
    getEventTicketType() {
        if (!this.questions_per_ticket && !this.email_per_ticket) {
            return 'GENERIC_TICKET_TYPE';
        }

        if (this.questions_per_ticket && this.email_per_ticket) {
            return 'QUESTIONS_PER_TICKET_TYPE';
        }

        if (!this.questions_per_ticket && this.email_per_ticket) {
            return 'DETAILS_PER_TICKET_TYPE';
        }
    }

    static $query(prms) {
        return eventChain.query(prms);
    }
}

export {
    EventChainModel
}